import { ListItemType } from '../../components/DailySchedule/ContentList';
import { IPAContent } from '../../model/dailySchedule';

export const days = [
  {
    id: '1',
    title: 'Segunda',
    subtitle: '23/12/2024',
  },
  {
    id: '2',
    title: 'Terça',
    subtitle: '24/12/2024',
  },
  {
    id: '3',
    title: 'Quarta',
    subtitle: '25/12/2024',
  },
  {
    id: '4',
    title: 'Quinta',
    subtitle: '26/12/2024',
  },
  {
    id: '5',
    title: 'Sexta',
    subtitle: '27/12/2024',
  },
  {
    id: '6',
    title: 'Sábado',
    subtitle: '28/12/2024',
  },
  {
    id: '7',
    title: 'Domingo',
    subtitle: '29/12/2024',
  },
];

export const timeline = [
  {
    _id: '671a902e91b946001cb4b1a1',
    text: 'Ponto 1',
    seconds: 26,
  },
  {
    _id: '671a902e91b946001cb4b1a2',
    text: 'Ponto 2',
    seconds: 52,
  },
  {
    _id: '671a902e91b946001cb4b1a3',
    text: 'Ponto 3',
    seconds: 78,
  },
  {
    _id: '671a902e91b946001cb4b1a4',
    text: 'Ponto 4',
    seconds: 104,
  },
  {
    _id: '671a902e91b946001cb4b1a5',
    text: 'Ponto 5',
    seconds: 130,
  },
  {
    _id: '671a902e91b946001cb4b1a6',
    text: 'Ponto 6',
    seconds: 156,
  },
  {
    _id: '671a902e91b946001cb4b1a7',
    text: 'Ponto 7',
    seconds: 182,
  },
  {
    _id: '671a902e91b946001cb4b1a8',
    text: 'Ponto 8',
    seconds: 208,
  },
  {
    _id: '671a902e91b946001cb4b1a9',
    text: 'Ponto 9',
    seconds: 234,
  },
  {
    _id: '671a902e91b946001cb4b1b0',
    text: 'Ponto 10',
    seconds: 260,
  },
  {
    _id: '671a902e91b946001cb4b1b1',
    text: 'Ponto 11',
    seconds: 286,
  },
];

export function orderBySubareaAndAddTitleSection(
  contentList: IPAContent[],
  addTitleSection: boolean = true
) {
  const sortedList = contentList.sort((a, b) => {
    if(!('content' in a) || !('content' in b)) return 0;

    if('subareaOrder' in a.content && 'subareaOrder' in b.content) {  
      if (a.content.subareaOrder !== b.content.subareaOrder) {
        return a.content.subareaOrder - b.content.subareaOrder;
      }
    }

    if('order' in a.content && 'order' in b.content) {
      return a.content.order - b.content.order;
    }

    return 0;
  });

  const newList: ListItemType[] = [];

  sortedList.forEach((item, index) => {
    if (
      addTitleSection &&
      (index === 0 ||
        sortedList[index - 1].content.slug_subarea !==
          item.content.slug_subarea)
    ) {
      newList.push({
        type: 'titleSection',
        title: item.content.title_subarea,
      });
    }
    newList.push(item);
  });

  return newList;
}

export function orderByType(contentList: ListItemType[]) {
  if(!contentList || contentList.length === 0) return [];

  const dividedList: ListItemType[][] = [];
  let auxArray: ListItemType[] = [];

  contentList.forEach(item => {
    if(item.type === 'titleSection') {
      if (auxArray.length > 0) {
        dividedList.push(auxArray);
      }
      
      auxArray = [item];
    } else {
      auxArray.push(item);
    }
  });

  if (auxArray.length > 0) {
    dividedList.push(auxArray);
  }

  dividedList.forEach(subArray => {
    subArray.sort((a, b) => {
      const order = ['titleSection', 'lesson', 'exercise', 'material'];
      return order.indexOf(a.type) - order.indexOf(b.type);
    });
  });

  const finalArray = dividedList.flat();

  return finalArray;
}

export function handleAllFirstContent(contentList: ListItemType[]) {
  const contents = contentList.filter(item => item.type !== 'titleSection');

  const firstContent = contents.find((item) => {
    if('content' in item) {
      return !item.content.done;
    }

    return false;
  });

  return firstContent;
}